<template>
  <el-row class="full-screen">
    <el-input
      v-model="search"
      size="mini"
      class="search"
      :placeholder="$t('user.tableHeader.search')"/>
    <el-table
      :data="users.filter(item => !search || ( item.username.toLowerCase().includes(search.toLowerCase()) || item.group.includes(search) ) )"
      style="width: 100%"
      height="100vh"
      ref="usersTable"
    >
      <el-table-column
        type="expand">
        <template slot-scope="props">
          <user-info :user="props" v-if="isAdmin"/>
          <user-info-simple :user="props"  v-else/>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('user.tableHeader.username')"
        prop="username">
      </el-table-column>
      <el-table-column
        :label="$t('user.tableHeader.email')"
        prop="email">
      </el-table-column>

      <el-table-column :label="$t('user.tableHeader.role')">
        <template scope="scope">
          {{getRole(scope.row.role)}}
        </template>
      </el-table-column>

      <el-table-column :label="$t('user.tableHeader.group')">
        <template scope="scope">
          {{scope.row.group}}
        </template>
      </el-table-column>

    </el-table>
  </el-row>
</template>

<script>
  // vuex
  import { mapGetters } from "vuex";

  // store
  import { GET_USERS } from "../../../../store/actions/users";

  // components
  import UserInfo from './UserInfo';
  import UserInfoSimple from './UserInfoSimple';

  export default {
    name: 'Users',
    data() {
      return {
        search: '',
        roles: this.$t('user.roles'),
      };
    },
    computed: {
      ...mapGetters([
        "users",
        "isAdmin",
      ]),
    },
    methods: {
      getRole(role) {
        return this.roles.find(item => item.name === role).title;
      },
    },
    components: {
      UserInfo,
      UserInfoSimple,
    },
    mounted() {
      this.$store.dispatch(GET_USERS);
    }
  };
</script>
<style>
 .search .el-input__inner{
    height: 40px;
    width: 85vw;
    max-width: 400px;
 }
 @media screen and (max-width: 480px) {
  .el-table{
      font-size: 10px;
  }
  .el-table .cell, .el-table th>.cell{
      padding-left: 5px;
      padding-right: 5px;
      word-break: break-word;
      line-height: unset;
  }
  .el-table__expanded-cell[class*=cell] {
      padding: 0px;
  }
  .el-form-item__label{
    font-size: 10px;
    line-height: unset;
  }
  .el-form-item {
    margin-bottom: 11px;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-drawer__header{
    margin-bottom: 0;
  }
  .full-screen{
    position: absolute;
    left: 0;
    right: 0;
  }
  .search{
    padding: 20px;
  }
 }
</style>
